// Plausible Analytics utility functions

declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: Record<string, string | number> }) => void;
  }
}

// User identifiers — set by AuthContext on sign-in, cleared on sign-out.
let _plausibleUserId: string | null = null;
let _plausibleUserEmail: string | null = null;

export const setPlausibleUser = (uid: string | null, email: string | null) => {
  _plausibleUserId = uid;
  _plausibleUserEmail = email;
};

// Legacy alias for backward compatibility
export const setPlausibleUserId = (uid: string | null) => {
  _plausibleUserId = uid;
};

export const trackEvent = (eventName: string, props?: Record<string, string | number>) => {
  if (typeof window !== 'undefined' && window.plausible) {
    const merged: Record<string, string | number> = { ...props };
    if (_plausibleUserId) merged.user_id = _plausibleUserId;
    if (_plausibleUserEmail) merged.user_email = _plausibleUserEmail;
    window.plausible(eventName, { props: merged });
  }
};

// Predefined event tracking functions
export const analytics = {
  viewedStartupDetail: (ideaId: string, ideaTitle: string) => {
    trackEvent('Viewed Startup Detail', { 
      idea_id: ideaId,
      idea_title: ideaTitle 
    });
  },
  
  clickedBuildThis: (ideaId: string, ideaTitle: string) => {
    trackEvent('Clicked Build This', { 
      idea_id: ideaId,
      idea_title: ideaTitle 
    });
  },
  
  clickedStartYourBusiness: (source: string) => {
    trackEvent('Clicked Start Your Business', { source });
  },
  
  visitedPricingPage: (source?: string) => {
    trackEvent('Visited Pricing Page', source ? { source } : undefined);
  },
};
